import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type * as Types from './type'

const initialState: Types.INotifySettingState = {
  logisticsStatus: { delivered: 0, arrived: 0, received: 0, station_closed: 0, station_changed: 0 },
  hiddenBrand: 0,
}

const notifySettingSlice = createSlice({
  name: 'notifySetting',
  initialState,
  reducers: {
    /**
     * 设置notify设置信息
     * @param state
     * @param action
     * @returns
     */
    setNotifySetting(state, action: PayloadAction<Types.IStatusState>) {
      const { hiddenBrand, logisticsStatus } = action.payload
      return {
        ...state,
        hiddenBrand,
        logisticsStatus,
      }
    },
  },
})
export const { setNotifySetting } = notifySettingSlice.actions
export default notifySettingSlice.reducer
